
const initialState = {
  isAuthenticated: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_WITH_TOKEN_REQUEST":
    case "LOGIN_REQUEST":
      return { ...state }
    case "LOGIN_WITH_TOKEN_SUCCESS":
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isAuthenticated: true,
      }
    case "LOGIN_WITH_TOKEN_FAILURE":
    case "LOGIN_FAILURE":
      return {
        ...state,
        isAuthenticated: false
      }
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// src/data/auth/reducer.js